import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Redirect, Route, Switch, withRouter } from 'react-router-dom'
import Amostras from './features/amostras/views/Amostras'
import Lotes from './features/lotes/views/Lotes'
import CadastroAmostras from './features/cadastroAmostras/views/CadastroAmostras'
import DadosLote from './features/dadosLote/views/DadosLote'
import Login from './features/login/views/Login'
import LoginCustomizado from './features/login/views/LoginCustomizado'
import AcessoNegado from '../src/shared/components/AcessoNegado'

const Routes = ({ autenticado }) => {
    let rotas = null

    if (autenticado) {
        rotas = (
            <Switch>
                <Route exact path={"/amostras"} component={Amostras} />
                <Route exact path={"/cadastro-amostras"} component={CadastroAmostras} />
                <Route exact path={"/lotes"} component={Lotes} />
                <Route exact path={"/dados-lote"} component={DadosLote} />
                <Redirect to={"/lotes"} component={Lotes} />
            </Switch>
        )
    }
    else {
        rotas = (
            <Switch>
                <Route exact path="/acesso-negado" component={AcessoNegado} />
                <Route exact path="/login-customizado" component={LoginCustomizado} />
                <Route exact path=":sessionId" component={Login} />
                <Route exact path="" component={Login} />
                <Redirect to="/" />
            </Switch>
        )
    }
    const AppRoutes = withRouter((p) => rotas)

    return <AppRoutes />
}

Routes.propTypes = {
    autenticado: PropTypes.bool.isRequired,
}

const mapStateToProps = state => ({
    autenticado: state.login.usuario != null
})

export default connect(mapStateToProps)(Routes)
